import { Box } from "@mui/material";
import { ModalV2 } from "../../shared/modal/modal";
import { TextFieldStyled } from "../../shared/styles";
import { useState } from "react";
import { Button } from "../../shared/button/button";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  getUserPortal,
  requestEmailChange,
} from "../../redux/actions/user.actions";
import { validateEmail } from "../../shared/utils";

const EMPTY_INPUT = {
  newEmail: "",
  currentPassword: { value: "", isVisible: false },
};

export const ModalChangeEmail = ({ open, handleClose }) => {
  const [input, setInput] = useState(EMPTY_INPUT);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  function close() {
    setInput(EMPTY_INPUT);
    handleClose();
  }

  function handleChangeEmail() {
    if (isLoading) return;

    if (!validateEmail(input.newEmail)) {
      toast.error(
        "Please enter a valid email address in the format: user@example.com"
      );
      return;
    }

    if (!input.currentPassword.value) {
      toast.error("Enter your current password");
      return;
    }

    const userId = localStorage.getItem("userId");
    if (!userId) {
      toast.error("User ID not found");
      return;
    }

    setIsLoading(true);
    requestEmailChange(userId, input.newEmail, input.currentPassword.value)
      .then((response) => {
        if (response?.status === 202) {
          toast.success("Check your new inbox to confirm the email change");
        } else {
          // Backend anterior: aplica el cambio directo (200).
          toast.success("Email updated");
          dispatch(getUserPortal(userId));
        }
        close();
      })
      .catch((error) => {
        const code = error?.response?.data?.code;
        if (code === "INVALID_CURRENT_PASSWORD") {
          toast.error("Current password is incorrect");
        } else if (code === "EMAIL_UNCHANGED") {
          toast.error("The new email is the same as the current one");
        } else if (error?.response?.status === 429) {
          toast.error("Too many attempts. Please try again later.");
        } else {
          toast.error("Error changing email");
        }
      })
      .finally(() => setIsLoading(false));
  }

  return (
    <ModalV2
      isOpen={open}
      title={"Change email"}
      handleClose={close}
      actionButtons={[
        {
          label: "Cancel",
          onClick: close,
        },
        {
          label: "Change email",
          onClick: handleChangeEmail,
        },
      ]}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={"8px"}
        px={"24px"}
        pb={"24px"}
      >
        <TextFieldStyled
          name={"newEmail"}
          placeholder={"New email"}
          type={"text"}
          value={input.newEmail}
          onChange={(e) =>
            setInput((prev) => ({ ...prev, newEmail: e.target.value }))
          }
        />
        <TextFieldStyled
          name={"currentPassword"}
          placeholder={"Current password"}
          type={input.currentPassword.isVisible ? "text" : "password"}
          value={input.currentPassword.value}
          onChange={(e) =>
            setInput((prev) => ({
              ...prev,
              currentPassword: { ...prev.currentPassword, value: e.target.value },
            }))
          }
          InputProps={{
            endAdornment: (
              <Button
                startIcon={input.currentPassword.isVisible ? "EyeSlash" : "Eye"}
                onClick={() =>
                  setInput((prev) => ({
                    ...prev,
                    currentPassword: {
                      ...prev.currentPassword,
                      isVisible: !prev.currentPassword.isVisible,
                    },
                  }))
                }
                type={"regular"}
              />
            ),
          }}
        />
      </Box>
    </ModalV2>
  );
};
